import React from 'react';
import DashboardMainContainer from '../../../components/common/Containers/DashboardMainContainer';

export default function AdminDashboardImageWidget({ title, image, alt }) {
  return (
    <DashboardMainContainer className="rounded-lg overflow-hidden bg-mistygray p-3 sm:p-4">
      <img
        src={image}
        alt={alt || title || 'Dashboard widget preview'}
        className="w-full h-auto rounded-lg border border-lightgray bg-white"
        loading="lazy"
      />
    </DashboardMainContainer>
  );
}
